<template>
   <div>
       <div class="content" :style='{width:(this.$store.state.windowwidth-this.$store.state.leftBlockWidth-this.$store.state.indexPadding*2)+"px"}'>
           <div class="common-items-center common-space-between">
               <div class="common-items-center">
                  <InputBlock title="角色名称">
                     <el-input v-model="name" :size="this.$store.state.inputSize" placeholder="请输入角色名称" onkeyup='value=value.replace(/^\s*|\s*$/g,"")'/>
                  </InputBlock>
                  <SelectBlock title="角色状态" placeholder="请选择角色状态" keyVal="enabled" ref="enabled" :size="this.$store.state.inputSize" width="160" @getVal="getValParms"/>
                  <el-button type="primary" icon="el-icon-search" :size="this.$store.state.btnSize"  @click="searchBtn">搜索</el-button>
                  <el-button type="danger"  icon="el-icon-refresh" :size="this.$store.state.btnSize"  @click="resetBtn">重置</el-button>
               </div>
               <el-button :size="this.$store.state.btnSize" type="primary" icon="el-icon-plus" @click="addRoule">新增</el-button>
           </div>
           <div class="warp-table">
            <el-table ref="giftTable" :data="tableData" :empty-text="this.$store.state.tableEmpty" :size="this.$store.state.tableSize" style="width: 100%"  row-key="id"  :height="this.$store.state.windowHeight-270" lazy>
               <el-table-column  align="center" header-align="center" :show-overflow-tooltip="true" prop="date"         label="序号"    width="50">
                  <template slot-scope="scope">{{scope.$index+1}}</template>
              </el-table-column>
               <el-table-column  align="left"   header-align="left"   :show-overflow-tooltip="true" prop="name"         label="角色名称"  width="180" ></el-table-column>
               <el-table-column  align="left"   header-align="left"   :show-overflow-tooltip="true" prop="roleDesc"     label="角色描述"  ></el-table-column>
               <el-table-column  align="center" header-align="center" :show-overflow-tooltip="true" prop="orderNo"      label="排序" width="80"></el-table-column>
               <el-table-column  align="center" header-align="center" :show-overflow-tooltip="true" prop="createTime"   label="更新时间" width="300"></el-table-column>
               <el-table-column  align="center" header-align="center" :show-overflow-tooltip="true" prop="operator"     label="最近操作人" width="200"> </el-table-column>
               <el-table-column  align="center" header-align="center" :show-overflow-tooltip="true" prop="enabled"      label="状态"     width="200">
                <template slot-scope="scope">
                    <span v-if="scope.row.enabled*1==1" class="open">启用</span> 
                    <span v-else class="disable">禁用</span>
                </template>  
              </el-table-column>
              <el-table-column  align="center" header-align="center" :show-overflow-tooltip="true" prop="orderNo"      label="操作"     width="90" fixed="right">
                  <template slot-scope="scope">
                     <div class="common-width common-space-around operate">
                       <el-link  :underline="false"  type="primary" size="mini" @click="update(scope.row)">编辑</el-link>
                       <el-popconfirm icon="el-icon-info" icon-color="#F03249" @confirm="deletnBtn(scope.row)" title="确定删除吗？" >
                          <el-link  :underline="false"  slot="reference" size="mini" :disabled='scope.row.roleType==2 ? true:false'  type="danger">删除</el-link>
                        </el-popconfirm>
                        <!-- <div v-if="!scope.row.mbIds">
                           <el-button  type="warning" size="mini" @click="authorityAddBtn(scope.row)">菜单</el-button>
                        </div>
                        <div v-else>
                           <el-button  type="success" size="mini" @click="authorityEidtBtn(scope.row)">菜单</el-button>
                        </div> -->
                     </div>
                  </template>    
              </el-table-column>
            </el-table>
            <Paging @getPage="getPage" :total="total" :pageNo="current" :size="size"/>
           </div>
       </div>
       <AddBlock ref="add" :options="options"></AddBlock>
       <UpdateBlock ref="update" :options="options"></UpdateBlock>
       <AuthorityAdd ref="authorityAdd"  :options="options"></AuthorityAdd>
       <AuthorityEidt ref="authorityEidt"  :options="options"></AuthorityEidt>
  </div>
</template>
<script>

import AddBlock from './common-module/add-block.vue'
import UpdateBlock from './common-module/update-block.vue'
import AuthorityAdd from './common-module/authority-block-add.vue'
import AuthorityEidt from './common-module/authority-block-eidt.vue'
import {url,userApi,operate} from '@/utils/config'
import {postFun,deleteFun,putFun,getFun} from '@/utils/httpFun'
import {scroll} from '../../../components/component-mixin/block-scroll'
export default {
  name: 'index',
  mixins:[scroll],
  components:{
     AddBlock:AddBlock,
     UpdateBlock:UpdateBlock,
     AuthorityAdd:AuthorityAdd,
     AuthorityEidt:AuthorityEidt
  },
  data:()=>({  
    queueID:0,
    options:[
       {code:"operate",indexNo:"1", selectName: "运维管理平台"},
       {code:"user",   indexNo:"2", selectName: "用户管理平台"},
       {code:"iot",    indexNo:"5", selectName: "IOT管理平台"},
    ],
    tableData: [{}],
    list: [
            { indexNo: '4', selectName: '禁用'}, 
            { indexNo: '2', selectName: '启用'}
          ],
    name:null,
    enabled:null,
    current:1,
    size:10,
    total:10,   
  }),
  created(){
    this.size = this.$store.state.pageSize
    this.getDatas()
   //  this.getPlatform()
  },
  methods:{

    //获取所有的数据
    async getDatas(){
      let parms = {
          param:{
            name:this.name,
            enabled:this.enabled
          },
          current:this.current,
          size:this.size
        }
        await postFun(userApi.ROULELIST,parms,res=>{
             this.tableData = res.data.records
             this.total = res.data.total
             this.size = res.data.size
             this.current = res.data.current
        })
    },

    //获取所有的平台
     async getPlatform(){
        await postFun(operate.MODULElIST,{},res=>{
          let listArray = []
          let list =  res.data  
          for(var i in list){
              if(list[i].enabled*1==1){
                listArray.push({
                  indexNo:list[i].id+"",
                  code:list[i].code,
                  selectName:list[i].name+""
                })
              }
          }
          this.options =  listArray        //多个平台
        })
    },


   //获取搜索框及其下拉的框的值
   getValParms(ev){
      if(ev.key=="enabled"){
         this.enabled = ev.indexNo
      }else{
         this.name = ev.val  
      }
    },

    //搜索
   searchBtn(){
      this.getDatas()
    },
   
   //重置 
   resetBtn(){
      this.name = null
      this.enabled = null
      this.current = 1
      this.$refs.enabled.setVal("")
      this.getDatas()
   },

    
    //新增角色
    addRoule(){
        this.$refs.add.showMessage(this.total)
    },

    //更新角色
    update(ev){
        this.$refs.update.showMessage(ev) 
    },
    
    //新增加色菜单
    authorityAddBtn(ev){
       this.$refs.authorityAdd.openWindw(ev)
    },
    
    //编辑角色菜单
    authorityEidtBtn(ev){
       this.$refs.authorityEidt.openWindw(ev)
    },

    //删除角色
    async deletnBtn(ev){
       let parms = {}
       await deleteFun(userApi.ROULEDELETE+"/"+ev.id,parms,res=>{
           this.getDatas() 
       })
    },

    //获取输入框/选择框的值
    getVal(ev){
       if(ev.key=="keyWord"){
           this.formData.keyWord = ev.val
       }
       if(ev.key=="status"){
           this.formData.status = ev.indexNo
       }
    },
    
    //分页
    getPage(ev){
        this.size = ev.pageSize
        this.current = ev.pageNo 
        this.getDatas()
    }
  }
}
</script>
<style lang="scss" scoped>
    .content{
       box-sizing: border-box;
       padding:15px;
    }
    .warp-table{
      margin-top: 15px;
    }
    .operate{
          ::v-deep .el-button--mini{
            padding: 5px 8px;
          }
       }
</style>
